export const PermissionSource = {
    LEFT_RAIL: "leftrail",
};
